// 輪巡（LIVE-05）：一組版面或攝影機清單，每 interval_seconds 換一頁（5–300 秒）。
// 存在版面的 tour 欄（vms.layouts.tour jsonb；個人或 org 共用版面都可以帶），形狀：
//   { interval_seconds, mode: 'cameras', cameras: ["<home>/<aid>", …] }——依目前格數分頁
//   { interval_seconds, mode: 'layouts', layouts: ["lay-…", …] }——輪流套用這些版面（格數 / 格子照各自的）
export const TOUR_INTERVALS = [5, 10, 15, 30, 60, 120, 300];

export interface TourSpec {
  interval_seconds: number;
  mode: 'cameras' | 'layouts';
  cameras?: string[];
  layouts?: string[];
}

export function clampInterval(s: number): number {
  return Math.min(300, Math.max(5, Math.round(s) || 10));
}

/** 攝影機清單依格數分頁；最後一頁補空格。沒有攝影機 → 0 頁。 */
export function tourPages(keys: string[], size: number): (string | null)[][] {
  const out: (string | null)[][] = [];
  for (let i = 0; i < keys.length; i += size) {
    const page: (string | null)[] = keys.slice(i, i + size);
    while (page.length < size) page.push(null);
    out.push(page);
  }
  return out;
}

/** 伺服器回的 tour（任意 JSON）→ 合法的 TourSpec；不合法回 null。 */
export function parseTour(v: unknown): TourSpec | null {
  if (!v || typeof v !== 'object') return null;
  const o = v as Record<string, unknown>;
  const interval_seconds = clampInterval(Number(o.interval_seconds));
  if (o.mode === 'cameras' && Array.isArray(o.cameras) && o.cameras.length)
    return { interval_seconds, mode: 'cameras', cameras: o.cameras.filter((x): x is string => typeof x === 'string') };
  if (o.mode === 'layouts' && Array.isArray(o.layouts) && o.layouts.length)
    return { interval_seconds, mode: 'layouts', layouts: o.layouts.filter((x): x is string => typeof x === 'string') };
  return null;
}
